// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ft5jQblquJTvIW {
  margin-bottom: var(--ds-space-400, 32px);
  font-size: medium;
  text-align: center;
}
.ZlkgnNraDpSdHn {
  display: flex;
}
.xCORiu6qPmmxV0 {
  color: var(--ds-text-subtle, #44546f);
  font-size: small;
}
.oPvo7EMzLHoyEc {
  margin-left: auto;
  color: var(--ds-link, #0c66e4);
  font-size: medium;
  text-decoration: none;
}
.oPvo7EMzLHoyEc:hover {
  text-decoration: underline;
}
.p9dhT0tTn1UdiF {
  display: flex;
  align-items: center;
  margin-top: var(--ds-space-050, 4px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-bottom: 28px;
}
.bs4vKIuN4vYNhX {
  flex-shrink: 0;
  margin-right: var(--ds-space-150, 12px);
}
.i2XIpfV6kfPJj8 {
  color: var(--ds-text, #172b4d);
  font-size: medium;
  overflow-wrap: anywhere;
}
.d2q8qateSXfamt {
  color: var(--ds-text-subtle, #44546f);
}
.jZjXRi1eU636kX {
  margin-bottom: var(--ds-space-200, 16px);
  color: var(--ds-text-subtlest, #626f86);
  font-size: small;
}
`, ""]);
// Exports
export var description = `ft5jQblquJTvIW`;
export var displayFlex = `ZlkgnNraDpSdHn`;
export var loginAsTitle = `xCORiu6qPmmxV0`;
export var switchAccountLink = `oPvo7EMzLHoyEc`;
export var memberInfoContainer = `p9dhT0tTn1UdiF`;
export var memberAvatar = `bs4vKIuN4vYNhX`;
export var fullName = `i2XIpfV6kfPJj8`;
export var email = `d2q8qateSXfamt`;
export var footerText = `jZjXRi1eU636kX`;
export default ___CSS_LOADER_EXPORT___;
